<button
  data-test-id="donate-button"
  [class]="isMenuItem ? 'menu-item-donate' : 'btn btn-primary btn-donate'"
  (click)="openDonateUrl()"
>
  <svg-icon src="assets/icons/icon-donate.svg" [class]="isMenuItem ? 'menu-item-icon' : 'button-icon'"></svg-icon>
  <span class="donate-button-label"> {{ 'DONATE_HINT' | translate }} </span>
</button>
